import {
  BooleanParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import { BrandParam } from '@/utils/query/params';

export const queryParams = {
  after: StringParam,
  before: StringParam,
  brand: BrandParam,
  desc: withDefault(BooleanParam, true),
  first: withDefault(NumberParam, 20),
  last: NumberParam,
};
